<script>

  export default {
    props: {
      item: {
        type: null,
        required: true,
      },
      type: {
        type: String,
        default: 'stock',
      },
      showStockSplit:{
        type: Boolean,
        default: false
      }
    },
    computed: {
      isReturnedStock(){
        if (this.item && this.item.tag){
          return ['returned'].indexOf(this.item.tag) !== -1
        }
        return false
      },
      stockTotal() {
        if (! Object.prototype.hasOwnProperty.call(this.item, 'warehouses')){
          return 0
        }
        const val = this.item.warehouses.map(elm => elm.stock_on_hand).reduce((a, b) => a + b, 0)
        if (val > 0)
          return  val
        return 0
      },
      stockReserved() {
        if (! Object.prototype.hasOwnProperty.call(this.item, 'warehouses')){
          return 0
        }
        const val = this.item.warehouses.map(elm => elm.stock_reserved).reduce((a, b) => a + b, 0)
        if (val > 0)
          return  val
        return 0
      },
      stockAvaliable() {
        if (! Object.prototype.hasOwnProperty.call(this.item, 'warehouses')){
          return 0
        }
        const val = this.stockTotal - this.stockReserved
        if (val > 0)
          return  val
        return 0
      },
      costPrice() {
        const cost = this.item.prices.find(price => price.key === 'cost')
        const costPrice = parseFloat(cost ? cost.amount : 0)
        return costPrice.toFixed(2)
      },
      rrpPrice(){
        const rrp = this.item.prices.find(price => price.key === 'rrp')
        const rrpPrice = parseFloat(rrp ? rrp.amount : 0)
        return rrpPrice.toFixed(2)
      },
      name(){
        if (this.item && this.item.name){
          let key = ''
          if (this.item.name.indexOf('(returned)') !== -1){
            key = '(returned)'
          }else if (this.item.name.indexOf('(Returned)') !== -1){
            key = '(Returned)'
          }
          return this.item.name.replace(key, '')
        }
        return ''
      },
      hasAnyWarehouseStock(){
        if (this.stockReserved === 0 && this.stockTotal === 0){
          return false
        }
        return true
      },
    },
    methods: {
      parseReservedDocumentRouteTo(type, reversedDocument) {
        const params = reversedDocument.project_id ? {id: reversedDocument.project_id} : {}
        const documentItem = { type, documentId: reversedDocument.id }
        return this.resolveRouterObjectForDocument(documentItem, params)
      },
    },
  }
</script>

<template>
  <ul class="default-list tw-max-w-4xl tw-pt-2">
    <li class="tw-flex tw-flex-col md:tw-flex-row md:tw-pb-3 md:tw-justify-between ">
      <span class="tw-text-black/75 tw-w-full md:tw-w-1/3">Model</span>
      <span
        class="
        tw-font-semibold md:tw-text-right
        tw-flex tw-flex-col
        tw-w-full md:tw-w-2/3
        tw-max-w-72 lg:tw-max-w-none
        tw-pl-12 md:tw-pl-0
        tw-pb-2 md:tw-pb-0">
        {{ item.code }}
      </span>
    </li>
    <li class="tw-flex tw-flex-col md:tw-flex-row md:tw-pb-3 md:tw-justify-between ">
      <span class="tw-text-black/75 tw-w-full md:tw-w-1/3">Name</span>
      <span
        class="
        tw-font-semibold md:tw-text-right
        tw-flex tw-flex-col
        tw-w-full md:tw-w-2/3
        tw-max-w-72 lg:tw-max-w-none
        tw-pl-12 md:tw-pl-0
        tw-pb-2 md:tw-pb-0">
        {{ name }} <span v-if="isReturnedStock" class="tx-col-red"> (Returned)</span>
      </span>
    </li>
    <li v-if="item.warehouses && hasAnyWarehouseStock" class="tw-flex tw-flex-col md:tw-flex-row md:tw-pb-3 md:tw-justify-between ">
      <span class="tw-text-black/75 tw-w-full md:tw-w-1/3">Warehouses</span>
      <span
        v-if="item.warehouses"
        class="
        tw-font-semibold md:tw-text-right
        tw-flex tw-flex-col
        tw-w-full md:tw-w-2/3
        tw-max-w-72 lg:tw-max-w-none
        tw-pl-12 md:tw-pl-0
        tw-pb-2 md:tw-pb-0">
        {{ item.warehouses.filter(elm => elm.stock_on_hand).map(elm => elm.name).join(', ') }}
      </span>
    </li>
    <li v-if="type === 'stock'" class="tw-flex tw-flex-col md:tw-flex-row md:tw-pb-3 md:tw-justify-between ">
      <span class="tw-text-black/75 tw-w-full md:tw-w-1/4">Status</span>
      <span class="tw-font-semibold md:tw-text-right tw-w-full md:tw-w-3/4 tw-pl-12 md:tw-pl-0 tw-flex md:tw-justify-end tw-justify-start">
        <BaseStatusPill
          class="tw-flex"
          :status="item.status.key"
          :value="item.status.name"
          enable-border />
      </span>
    </li>
    <li v-else-if="type === 'product' && item.status.key === 'active'" class="tw-flex tw-flex-col md:tw-flex-row md:tw-pb-3 md:tw-justify-between ">
      <span class="tw-text-black/75 tw-w-full md:tw-w-1/4">Status</span>
      <span class="tw-font-semibold md:tw-text-right tw-w-full md:tw-w-3/4 tw-pl-12 md:tw-pl-0 tw-flex md:tw-justify-end tw-justify-start">
        <BaseStatusPill
          class="tw-flex"
          extra-classes="tw-ml-2"
          :status="item.status.key"
          value="Available to Order"
          enable-border />
      </span>
    </li>
    <li v-else-if="type === 'product' && item.status.key !== 'active'" class="tw-flex tw-flex-col md:tw-flex-row md:tw-pb-3 md:tw-justify-between ">
      <span class="tw-text-black/75 tw-w-full md:tw-w-1/4">Status</span>
      <span class="tw-font-semibold md:tw-text-right tw-w-full md:tw-w-3/4 tw-pl-12 md:tw-pl-0 tw-flex md:tw-justify-end tw-justify-start">
        <BaseStatusPill
          class="tw-flex"
          extra-classes="tw-ml-2"
          :status="item.status.key"
          :value="item.status.name"
          enable-border />
      </span>
    </li>
    <li v-if="type === 'stock' && item.warehouses && showStockSplit" class="tw-flex tw-flex-col md:tw-flex-row md:tw-pb-3 md:tw-justify-between ">
      <span class="tw-text-black/75 tw-w-full md:tw-w-1/4">Stock</span>
      <span class="tw-font-semibold md:tw-text-right tw-w-full md:tw-w-3/4 tw-pl-12 md:tw-pl-0 tw-flex tw-flex-col md:tw-justify-end tw-justify-start">
        <span class="tx-col-black tw-whitespace-nowrap">Total: {{ stockTotal }}</span>
        <span class="tx-col-dark-green tw-whitespace-nowrap">Available: {{ stockAvaliable }}</span>
        <span class="tx-col-light-blue tw-flex tw-flex-col md:tw-flex-row-reverse">
          <span class="tw-pr-4 md:tw-pl-4 md:tw-pr-u tw-text-positive tw-whitespace-nowrap">Reserved: {{ stockReserved }}</span>
          <div
            v-if="item.reserved_documents"
            class="tw-pl-4 md:tw-pl-u">
            <span
              v-for="reservedDocumentItem in item.reserved_documents"
              :key="reservedDocumentItem.name"
              class="tw-flex tw-flex-wrap">
              <span
                v-for="reservedDocument in reservedDocumentItem.documents"
                :key="reservedDocument.id">
                <router-link
                  :to="parseReservedDocumentRouteTo(reservedDocumentItem.type, reservedDocument)"
                  class="tw-mr-2 tw-underline tw-whitespace-nowrap tw-decoration-primaryLightened tw-text-primaryLightened hover:tw-decoration-black hover:tw-text-gray-800"
                >
                  {{ reservedDocument.name }} ({{ reservedDocument.quantity }})
                </router-link>
              </span>
            </span>
          </div>
        </span>
      </span>
    </li>
    <li v-if="item.supplier" class="tw-flex tw-flex-col md:tw-flex-row md:tw-pb-3 md:tw-justify-between ">
      <span class="tw-text-black/75 tw-w-full md:tw-w-1/3">Supplier</span>
      <span
        class="
        tw-font-semibold md:tw-text-right
        tw-flex tw-flex-col
        tw-w-full md:tw-w-2/3
        tw-max-w-72 lg:tw-max-w-none
        tw-pl-12 md:tw-pl-0
        tw-pb-2 md:tw-pb-0">
        {{ item.supplier.name }}
      </span>
    </li>
    <li v-if="item.brand" class="tw-flex tw-flex-col md:tw-flex-row md:tw-pb-3 md:tw-justify-between ">
      <span class="tw-text-black/75 tw-w-full md:tw-w-1/3">Brand</span>
      <span
        class="
        tw-font-semibold md:tw-text-right
        tw-flex tw-flex-col
        tw-w-full md:tw-w-2/3
        tw-max-w-72 lg:tw-max-w-none
        tw-pl-12 md:tw-pl-0
        tw-pb-2 md:tw-pb-0">
        {{ item.brand.name }}
      </span>
    </li>
    <BaseMultipleCategoryItem v-if="item.category && item.category.parent && item.category.parent.parent" :category="item.category.parent.parent" tailwind/>
    <BaseMultipleCategoryItem v-if="item.category && item.category.parent" :category="item.category.parent" tailwind/>
    <BaseMultipleCategoryItem v-if="item.category" :category="item.category" tailwind/>
    <li v-if="item.rrp" class="tw-flex tw-flex-col md:tw-flex-row md:tw-pb-3 md:tw-justify-between ">
      <span class="tw-text-black/75 tw-w-full md:tw-w-1/3">RRP</span>
      <span
        class="
        tw-font-semibold md:tw-text-right
        tw-flex tw-flex-col
        tw-w-full md:tw-w-2/3
        tw-max-w-72 lg:tw-max-w-none
        tw-pl-12 md:tw-pl-0
        tw-pb-2 md:tw-pb-0">
        ${{ item.rrp }}</span>
    </li>
    <li v-else-if="!Object.prototype.hasOwnProperty.call(item, 'rrp') && item.prices.findIndex(price => price.key === 'rrp') !== -1" class="tw-flex tw-flex-col md:tw-flex-row md:tw-pb-3 md:tw-justify-between ">
      <span class="tw-text-black/75 tw-w-full md:tw-w-1/3">RRP</span>
      <span
        class="
        tw-font-semibold md:tw-text-right
        tw-flex tw-flex-col
        tw-w-full md:tw-w-2/3
        tw-max-w-72 lg:tw-max-w-none
        tw-pl-12 md:tw-pl-0
        tw-pb-2 md:tw-pb-0">
        ${{ rrpPrice }}
      </span>
    </li>
    <li v-if="item.cost_price" class="tw-flex tw-flex-col md:tw-flex-row md:tw-pb-3 md:tw-justify-between ">
      <span class="tw-text-black/75 tw-w-full md:tw-w-1/3">Cost Price</span>
      <span
        class="
        tw-font-semibold md:tw-text-right
        tw-flex tw-flex-col
        tw-w-full md:tw-w-2/3
        tw-max-w-72 lg:tw-max-w-none
        tw-pl-12 md:tw-pl-0
        tw-pb-2 md:tw-pb-0">${{ item.cost_price }}</span>
    </li>
    <li v-else-if="!Object.prototype.hasOwnProperty.call(item, 'cost_price') && item.prices.findIndex(price => price.key === 'cost') !== -1" class="tw-flex tw-flex-col md:tw-flex-row md:tw-pb-3 md:tw-justify-between ">
      <span class="tw-text-black/75 tw-w-full md:tw-w-1/3">Cost Price</span>
      <span
        class="
        tw-font-semibold md:tw-text-right
        tw-flex tw-flex-col
        tw-w-full md:tw-w-2/3
        tw-max-w-72 lg:tw-max-w-none
        tw-pl-12 md:tw-pl-0
        tw-pb-2 md:tw-pb-0">
        ${{ costPrice }}
      </span>
    </li>
    <li v-if="item.weight" class="tw-flex tw-flex-col md:tw-flex-row md:tw-pb-3 md:tw-justify-between ">
      <span class="tw-text-black/75 tw-w-full md:tw-w-1/3">Weight</span>
      <span
        class="
        tw-font-semibold md:tw-text-right
        tw-flex tw-flex-col
        tw-w-full md:tw-w-2/3
        tw-max-w-72 lg:tw-max-w-none
        tw-pl-12 md:tw-pl-0
        tw-pb-2 md:tw-pb-0">{{ item.weight }} kg</span>
    </li>
    <li v-if="item.width" class="tw-flex tw-flex-col md:tw-flex-row md:tw-pb-3 md:tw-justify-between ">
      <span class="tw-text-black/75 tw-w-full md:tw-w-1/3">Width</span>
      <span
        class="
        tw-font-semibold md:tw-text-right
        tw-flex tw-flex-col
        tw-w-full md:tw-w-2/3
        tw-max-w-72 lg:tw-max-w-none
        tw-pl-12 md:tw-pl-0
        tw-pb-2 md:tw-pb-0">{{ item.width }} mm</span>
    </li>
    <li v-if="item.height" class="tw-flex tw-flex-col md:tw-flex-row md:tw-pb-3 md:tw-justify-between ">
      <span class="tw-text-black/75 tw-w-full md:tw-w-1/3">Height</span>
      <span
        class="
        tw-font-semibold md:tw-text-right
        tw-flex tw-flex-col
        tw-w-full md:tw-w-2/3
        tw-max-w-72 lg:tw-max-w-none
        tw-pl-12 md:tw-pl-0
        tw-pb-2 md:tw-pb-0">{{ item.height }} mm</span>
    </li>
    <li v-if="item.length" class="tw-flex tw-flex-col md:tw-flex-row md:tw-pb-3 md:tw-justify-between ">
      <span class="tw-text-black/75 tw-w-full md:tw-w-1/3">Length</span>
      <span
        class="
        tw-font-semibold md:tw-text-right
        tw-flex tw-flex-col
        tw-w-full md:tw-w-2/3
        tw-max-w-72 lg:tw-max-w-none
        tw-pl-12 md:tw-pl-0
        tw-pb-2 md:tw-pb-0">{{ item.length }} mm</span>
    </li>
    <li v-if="item.warranty_parts" class="tw-flex tw-flex-col md:tw-flex-row md:tw-pb-3 md:tw-justify-between ">
      <span class="tw-text-black/75 tw-w-full md:tw-w-1/3">Warranty Parts</span>
      <span
        class="
        tw-font-semibold md:tw-text-right
        tw-flex tw-flex-col
        tw-w-full md:tw-w-2/3
        tw-max-w-72 lg:tw-max-w-none
        tw-pl-12 md:tw-pl-0
        tw-pb-2 md:tw-pb-0">{{ item.warranty_parts }}</span>
    </li>
    <li v-if="item.warranty_labour" class="tw-flex tw-flex-col md:tw-flex-row md:tw-pb-3 md:tw-justify-between ">
      <span class="tw-text-black/75 tw-w-full md:tw-w-1/3">Warranty Labour</span>
      <span
        class="
        tw-font-semibold md:tw-text-right
        tw-flex tw-flex-col
        tw-w-full md:tw-w-2/3
        tw-max-w-72 lg:tw-max-w-none
        tw-pl-12 md:tw-pl-0
        tw-pb-2 md:tw-pb-0">{{ item.warranty_labour }}</span>
    </li>
    <li v-if="item.attachments && item.attachments.length" class="tw-flex tw-flex-col md:tw-flex-row md:tw-pb-3 md:tw-justify-between ">
      <span class="text-label">Attachments</span>
      <ul class="pd-l-15">
        <li v-for="attachment in item.attachments" :key="attachment.id" class="list-solid">
          <span class="text-value text-bold"><a :href="attachment.url" target="_blank">{{ attachment.name }}</a></span>
        </li>
      </ul>
    </li>
  </ul>
</template>
